// Secondary-admin: supervisors share the AdminLayout, which renders the
// supervisor menu variant (no Dashboard/Clients/Audit, clock-in landing).
import AdminLayout from './AdminLayout';

export default function SupervisorLayout({ children }) {
  return <AdminLayout>{children}</AdminLayout>;
}
